/** Motif d'icônes en filigrane de la zone principale (maquette 2a, opacité .1). Purement décoratif. */
export function Doodle() {
  return (
    <div aria-hidden="true" className="hm-doodle">
      <svg width="100%" height="100%">
        <defs>
          <pattern id="lh-doodle" width="280" height="250" patternUnits="userSpaceOnUse">
            <g fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <g transform="translate(20 20) rotate(-12 12 12)"><path d="M12 15a4 4 0 11-8 0 4 4 0 018 0zM11 12l9-9M16 7l3 3" /></g>
              <g transform="translate(110 50) rotate(10 12 12)"><path d="M5 12l5 5 9-10" /></g>
              <g transform="translate(190 14) rotate(-6 12 12)"><path d="M4 11l8-7 8 7v9H4z" /></g>
              <g transform="translate(60 110) rotate(8 12 12)"><path d="M4 6h16v14H4zM4 11h16M9 3v4M15 3v4" /></g>
              <g transform="translate(150 130) rotate(-14 12 12)"><path d="M12 4a4 4 0 100 8 4 4 0 000-8zM4 20c0-4 4-6 8-6s8 2 8 6" /></g>
              <g transform="translate(230 100) rotate(12 12 12)"><path d="M10.5 4a6.5 6.5 0 100 13 6.5 6.5 0 000-13zM16 16l4 4" /></g>
              <g transform="translate(14 190) rotate(6 12 12)"><path d="M3 6h18v12H3zM3 10h18" /></g>
              <g transform="translate(100 215) rotate(-8 12 12)"><path d="M6 3h9l3 3v15H6zM9 12h6M9 16h6" /></g>
              <g transform="translate(185 205) rotate(14 12 12)"><path d="M12 21s-6-6-6-11a6 6 0 0112 0c0 5-6 11-6 11zM12 8a2 2 0 100 4 2 2 0 000-4z" /></g>
              <g transform="translate(250 180)"><path d="M12 5v14M5 12h14" /></g>
            </g>
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#lh-doodle)" />
      </svg>
    </div>
  );
}
